import React from 'react';
import { Grid, Typography } from '@mui/material';
import useStyles from './styles';
import SpalshImage from '../../assets/images/receipt.png';
import { getVersion } from '../../util/tools';

function Home() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid className={classes.root}>
        <Grid className={classes.gridImage}>
          <img
            data-testid="img-attribute"
            src={SpalshImage}
            alt={'Pido'}
            className={classes.image}
          />
        </Grid>
        <Grid className={classes.gridVersion}>
          <Typography
            data-testid="config-content"
            className={classes.version}
            variant="h5"
          >
            {'ورژن اپلیکیشن : ' + getVersion()}
          </Typography>
          <Typography className={classes.privacy} variant="body1">
            کلیه حقوق این اپلیکیشن متعلق به شرکت تجارت الکترونیک آیریک پارسیان می باشد
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Home;
